module.exports = __webpack_public_path__ + "media/images/pic/certificates/forbes-8d6227e5f07adfaacd9fad44929b8748.png";